/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightObservedPrice
 */
export interface FlightObservedPrice {
    /**
     *
     * @type {number}
     * @memberof FlightObservedPrice
     */
    totalAmount: number;
    /**
     *
     * @type {string}
     * @memberof FlightObservedPrice
     */
    currency: string;
}

/**
 * Check if a given object implements the FlightObservedPrice interface.
 */
export function instanceOfFlightObservedPrice(value: object): value is FlightObservedPrice {
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function FlightObservedPriceFromJSON(json: any): FlightObservedPrice {
    return FlightObservedPriceFromJSONTyped(json, false);
}

export function FlightObservedPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightObservedPrice {
    if (json == null) {
        return json;
    }
    return {

        'totalAmount': json['total_amount'],
        'currency': json['currency'],
    };
}

export function FlightObservedPriceToJSON(json: any): FlightObservedPrice {
    return FlightObservedPriceToJSONTyped(json, false);
}

export function FlightObservedPriceToJSONTyped(value?: FlightObservedPrice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'total_amount': value['totalAmount'],
        'currency': value['currency'],
    };
}
